
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class CampaignTemplatesDialog extends Serenity.EntityDialog<CampaignTemplatesRow, any> {
        protected getFormKey() { return CampaignTemplatesForm.formKey; }
        protected getIdProperty() { return CampaignTemplatesRow.idProperty; }
        protected getLocalTextPrefix() { return CampaignTemplatesRow.localTextPrefix; }
        protected getNameProperty() { return CampaignTemplatesRow.nameProperty; }
        protected getService() { return CampaignTemplatesService.baseUrl; }
        protected getDeletePermission() { return CampaignTemplatesRow.deletePermission; }
        protected getInsertPermission() { return CampaignTemplatesRow.insertPermission; }
        protected getUpdatePermission() { return CampaignTemplatesRow.updatePermission; }

        protected form = new CampaignTemplatesForm(this.idPrefix);
        constructor() {
            super();
            this.form.ProviderTypeId.changeSelect2(e => {
                if (this.form.ProviderTypeId.value.toString() == "250" || this.form.ProviderTypeId.value.toString() == "253") {
                    this.form.Message.getGridField().toggle(true);
                    this.form.Title.getGridField().toggle(false);
                    this.form.Image.getGridField().toggle(false);
                    this.form.Html.getGridField().toggle(false);
                } else if (this.form.ProviderTypeId.value.toString() == "252") {
                    this.form.Message.getGridField().toggle(true);
                    this.form.Title.getGridField().toggle(true);
                    this.form.Image.getGridField().toggle(true);
                    this.form.Html.getGridField().toggle(false);
                } else if (this.form.ProviderTypeId.value.toString() == "251") {
                    this.form.Message.getGridField().toggle(true);
                    this.form.Title.getGridField().toggle(true);
                    this.form.Image.getGridField().toggle(false);
                    this.form.Html.getGridField().toggle(true);
                }

            })
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.ProviderTypeId.value != "") {
                if (this.form.ProviderTypeId.value.toString() == "250" || this.form.ProviderTypeId.value.toString() == "253") {
                    this.form.Message.getGridField().toggle(true);
                    this.form.Title.getGridField().toggle(false);
                    this.form.Image.getGridField().toggle(false);
                    this.form.Html.getGridField().toggle(false);
                } else if (this.form.ProviderTypeId.value.toString() == "252") {
                    this.form.Message.getGridField().toggle(true);
                    this.form.Title.getGridField().toggle(true);
                    this.form.Image.getGridField().toggle(true);
                    this.form.Html.getGridField().toggle(false);
                } else if (this.form.ProviderTypeId.value.toString() == "251") {
                    this.form.Message.getGridField().toggle(true);
                    this.form.Title.getGridField().toggle(true);
                    this.form.Image.getGridField().toggle(false);
                    this.form.Html.getGridField().toggle(true);
                }

            } else {
                this.form.Message.getGridField().toggle(false);
                this.form.Title.getGridField().toggle(false);
                this.form.Image.getGridField().toggle(false);
                this.form.Html.getGridField().toggle(false);
            }
        }
    }
}